import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EligibiliteBeneficiaire } from 'src/app/shared/models/eligibiliteBeneficiaire';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EligibiliteBeneficiaireModalAjoutComponent } from '../modal/eligibiliteBeneficiaire-modal-ajout/eligibiliteBeneficiaire-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { EligibiliteBeneficiaireModalDetailComponent } from '../modal/eligibiliteBeneficiaire-modal-detail/eligibiliteBeneficiaire-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-eligibiliteBeneficiaire',
	templateUrl: './list-eligibiliteBeneficiaire.component.html',
	styleUrls: ['./list-eligibiliteBeneficiaire.component.scss']
})
export class ListEligibiliteBeneficiaireComponent implements OnInit {
	eligibiliteBeneficiaire: EligibiliteBeneficiaire[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	eligibiliteBeneficiaireCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editEligibiliteBeneficiaireModalRef: BsModalRef;
	addEligibiliteBeneficiaireModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getEligibiliteBeneficiaire();
		this.isAddable = true;
	}

	getEligibiliteBeneficiaire(): void {
		this.isListingLoading = true;
		this.facade.eligibiliteBeneficiaireService.getAllEligibiliteBeneficiaire().subscribe({
			next: (val) => {
				this.eligibiliteBeneficiaire = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.eligibiliteBeneficiaire.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.eligibiliteBeneficiaire = [];
			}
		});
	}

	selectEligibiliteBeneficiaire(eligibiliteBeneficiaire: EligibiliteBeneficiaire): void {
		const link = ['/eligibiliteBeneficiaire', eligibiliteBeneficiaire.id];
		this.router.navigate(link);
	}

	importEligibiliteBeneficiaire(event: any): void {
		this.eligibiliteBeneficiaireCsvFile = event.target.files[0];

		this.facade.eligibiliteBeneficiaireService
			.importEligibiliteBeneficiaire(this.eligibiliteBeneficiaireCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} eligibiliteBeneficiaire ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getEligibiliteBeneficiaire();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addEligibiliteBeneficiaireModalRef = this.modalService.show(
			EligibiliteBeneficiaireModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addEligibiliteBeneficiaireModalRef.onHide.subscribe((reason: string | any) => {
			this.getEligibiliteBeneficiaire();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(eligibiliteBeneficiaire: EligibiliteBeneficiaire) {
		const initialState = {
			eligibiliteBeneficiaire: eligibiliteBeneficiaire
		};
		this.editEligibiliteBeneficiaireModalRef = this.modalService.show(
			EligibiliteBeneficiaireModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editEligibiliteBeneficiaireModalRef.onHide.subscribe((reason: string | any) => {
			this.getEligibiliteBeneficiaire();
		});
	}
}
